import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export type ButtonColor = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger' | 'link';
export type ButtonSize = 'lg' | 'sm' | 'xs' | 'block' | 'default';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
    /**
     * Inputs
     */
    @Input() color: ButtonColor;
    @Input() size: ButtonSize;
    @Input() className = '';
    @Input() type = 'submit';
    @Input() loading = false;
    @Input() disabled = false;
    @Input() loadingText;

    /**
     * Outputs
     */
    @Output() onClick = new EventEmitter<void>();

    constructor() {
    }

    get classList() {
        const classList = ['btn'];
        if (this.color) {
            classList.push(`btn-${this.color}`);
        }

        if (this.size && this.size !== 'default') {
            classList.push(`btn-${this.size}`);
        }

        if (this.className) {
            classList.push(this.className);
        }

        if (this.loading) {
            classList.push('btn-loading');
        }

        return classList.join(' ');
    }

    ngOnInit() {
    }
}
